export const engagementInAppMessageColorProfilesDefault = "/engagement/in_app_message_color_profiles/default";
